import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { ActionButton } from './ActionButton';
function useCountdown() {
  const [seconds, setSeconds] = useState(23 * 3600 + 55 * 60 + 21);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(value => String(value).padStart(2, '0'));
}
interface PricingProps {
  showAnchor?: boolean;
}
export function Pricing({
  showAnchor = false
}: PricingProps) {
  const [hours, minutes, seconds] = useCountdown();
  return <section id={showAnchor ? 'pricing' : undefined} className="bg-brand-dark" data-id="element-95" data-mp="20rjxg2c1lex7">
      <div className="bg-[#1c0909] px-4 py-16 sm:py-20" data-id="element-96" data-mp="3h63amgplf4s5">
        <div className="mx-auto max-w-4xl text-center" data-id="element-97" data-mp="3c8jx5j0pyw19">
          <h2 className="font-display text-xl font-bold sm:text-2xl" data-id="element-98" data-mp="3c7s3idqon8dm">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <div className="mt-6 flex justify-center gap-3 sm:gap-6" data-id="element-99" data-mp="4t5mjfll1dzm">
            {[[hours, 'HS'], [minutes, 'MIN'], [seconds, 'SEG']].map(([value, label], index) => <Fragment key={label} data-id="element-100" data-mp="9qe69kmdpq2z" data-mpi={index}>
                  <div data-id="element-101" data-mp="erletlwcitap">
                    <p className="font-display text-5xl font-bold text-red-500 sm:text-7xl" data-id="element-102" data-mp="eq0m81tldkfh">
                      {value}
                    </p>
                    <p className="text-xs tracking-[.2em] text-slate-400" data-id="element-103" data-mp="3i81ycn63dhbg">{label}</p>
                  </div>
                  {index < 2 && <span className="pt-2 font-display text-4xl text-red-500 sm:text-6xl" data-id="element-104" data-mp="3n6d70uknhls3">
                      :
                    </span>}
                </Fragment>)}
          </div>
          <p className="mt-6 text-slate-400" data-id="element-105" data-mp="2ugdbhmc1hl1w">
            Después sube. <b className="text-white" data-id="element-106" data-mp="2zgiw4ijw67ah">No vuelve.</b>
          </p>
          <div className="mx-auto mt-5 max-w-md rounded-xl border border-red-500/20 bg-brand-ink p-4 text-left" data-id="element-107" data-mp="2rguxx8i4nmb3">
            <div className="flex justify-between text-sm font-medium text-red-400" data-id="element-108" data-mp="2mibd5bf9sgkb">
              <span data-id="element-109" data-mp="316o8q7ag3xea">Cupos al precio de lanzamiento</span>
              <span data-id="element-110" data-mp="3164v32rtvv62">Quedan pocos</span>
            </div>
            <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-slate-800" data-id="element-111" data-mp="2w71o3csafevg">
              <div className="h-full w-[71%] rounded-full bg-red-500" data-id="element-112" data-mp="28i0hzw6xgftc" />
            </div>
            <p className="mt-2 text-right text-xs text-slate-500" data-id="element-113" data-mp="28jtrdj8xde51">
              71% de los cupos ya tomados
            </p>
          </div>
        </div>
      </div>
      <div className="px-4 py-16 sm:py-24" data-id="element-114" data-mp="2ihrfm6qsbaxn">
        <div className="mx-auto max-w-2xl" data-id="element-115" data-mp="2dhd76nl9tyz3">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-116" data-mp="2dgajspn5qenx">
            TU KIT COMPLETO
          </h2>
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-8 rounded-3xl border-2 border-brand-green bg-brand-ink p-6 shadow-[0_0_30px_rgba(22,163,74,.13)] sm:p-9" data-id="element-117" data-mp="3txg4x4rigm1m">
            <div className="flex flex-col gap-4 sm:flex-row sm:justify-between" data-id="element-118" data-mp="5arrg4144vex">
              <div data-id="element-119" data-mp="3ngo0khynlits">
                <h3 className="font-display text-lg font-bold text-brand-light" data-id="element-120" data-mp="3nh684aqrnjh0">
                  🌿 KIT ACUERDOS DE CUIDADO™
                </h3>
                <p className="mt-1 text-sm text-slate-400" data-id="element-121" data-mp="j0lhgpoctlq8">
                  3 Volúmenes + 5 Bonos · Acceso inmediato
                </p>
                <p className="mt-3 text-sm text-brand-light" data-id="element-122" data-mp="nz6jmun62fhb">
                  Tu kit completo en PDF + 5 bonos estratégicos de regalo.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-123" data-mp="e8u27banf2fe">
                <p className="text-xs uppercase tracking-wider text-slate-500" data-id="element-124" data-mp="11zr4rxgk0ndz">
                  Precio original
                </p>
                <p className="text-slate-500 line-through" data-id="element-125" data-mp="16rhhub6vlp93">$65.000 ARS</p>
                <p className="mt-2 text-xs uppercase tracking-wider text-brand-light/70" data-id="element-126" data-mp="3f78vqnk3xvjx">
                  Precio lanzamiento
                </p>
                <p className="font-display text-4xl font-bold text-brand-light" data-id="element-127" data-mp="3a6ukyxr4g7i7">
                  $19.990
                </p>
                <p className="text-xs text-slate-400" data-id="element-128" data-mp="35b5s1d9lxouv">ARS</p>
              </div>
            </div>
          </motion.div>
          <ActionButton className="mt-7" showTrust data-id="element-129" data-mp="1scj5drrxo71">
            QUIERO MIS ACUERDOS AHORA
          </ActionButton>
        </div>
      </div>
    </section>;
}